import React from 'react';
import { UserIcon, MailIcon, PhoneIcon, BriefcaseIcon, LinkedinIcon, BuildingIcon, MapPinIcon, DollarSignIcon, CpuIcon } from 'lucide-react';
export function DatabaseFields() {
  return <section className="py-24 bg-slate-50" data-id="element-2266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2267">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2268">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-2269">
            Comprehensive{' '}
            <span className="text-blue-600" data-id="element-2270">local business listings</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-2271">
            Our local business database provides deep employee-level data, so
            you can reach the exact decision maker with verified business owner
            emails every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2272">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2273">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2274">
              <UserIcon className="w-6 h-6" data-id="element-2275" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2276">
              Owner Names
            </h3>
            <p className="text-slate-600" data-id="element-2277">
              First and last names of local business owners, founders, and
              managers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2278">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2279">
              <MailIcon className="w-6 h-6" data-id="element-2280" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2281">
              Business Owner Emails
            </h3>
            <p className="text-slate-600" data-id="element-2282">
              Direct business owner emails and employee lists, verified in
              real-time.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2283">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2284">
              <BriefcaseIcon className="w-6 h-6" data-id="element-2285" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2286">
              Job Titles
            </h3>
            <p className="text-slate-600" data-id="element-2287">
              Filter by Owner, Founder, GM, Marketing Director, etc.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2288">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2289">
              <PhoneIcon className="w-6 h-6" data-id="element-2290" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2291">
              Direct Phones
            </h3>
            <p className="text-slate-600" data-id="element-2292">
              Mobile and direct dial numbers for key decision makers.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2293">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2294">
              <LinkedinIcon className="w-6 h-6" data-id="element-2295" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2296">
              Social Profiles
            </h3>
            <p className="text-slate-600" data-id="element-2297">
              LinkedIn profiles for employees and the company.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2298">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2299">
              <BuildingIcon className="w-6 h-6" data-id="element-2300" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2301">
              Firmographics
            </h3>
            <p className="text-slate-600" data-id="element-2302">
              Company size, employee count, and founding year.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2303">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2304">
              <MapPinIcon className="w-6 h-6" data-id="element-2305" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2306">
              Location Data
            </h3>
            <p className="text-slate-600" data-id="element-2307">
              Precise HQ addresses and multi-location branch data.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2308">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2309">
              <DollarSignIcon className="w-6 h-6" data-id="element-2310" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2311">
              Revenue Estimates
            </h3>
            <p className="text-slate-600" data-id="element-2312">
              Estimated annual revenue to qualify your local business leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-2313">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-2314">
              <CpuIcon className="w-6 h-6" data-id="element-2315" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-2316">
              Tech Stack
            </h3>
            <p className="text-slate-600" data-id="element-2317">
              Technologies used by the business (Shopify, Toast, etc).
            </p>
          </div>
        </div>
      </div>
    </section>;
}